<template>
    <div :class="formClasses" :style="hasMaxWidth ? maxWidthStyle : ''">

        <input v-if="isPassword && isString"
               type="password" class="form-control" :placeholder="field.name"
               :class="textInputClasses"
               v-model="document[field.index]" @blur="saveDocument">

        <input v-else-if="isString"
               type="text" class="form-control" :placeholder="field.name"
               :class="textInputClasses"
               v-model="document[field.index]" @blur="saveDocument">

        <input v-else-if="field.field_type === 'Number'" type="number" class="form-control"
               v-model="document[field.index]" @blur="onValidateNumber" :placeholder="field.name">

        <checkbox-view v-else-if="field.field_type === 'Boolean'" :document="document"
                       :field-name="field.index" :editable="true" :key="field.id + 'edit'"
                       :table="table" alignment-class="justify-content-left"></checkbox-view>

        <datepicker v-else-if="field.field_type === 'Date'"  v-model="document[field.index]" :name="table.slug + 'Datepicker'"
                    @closed="dateClosed()"></datepicker>

        <select-control v-else-if="field.field_type === 'Single Select'"
                        :key="field.id + 'selectedit'" :document="document" @blur="saveDocument"
                        :field="field" :table="table" @change="saveDocument"></select-control>

        <select-collaborator v-else-if="field.field_type === 'Collaborator'"
                             :key="field.id + 'SelectCollaborator'" :document="document"
                             :field="field" :table="table"></select-collaborator>


        <image-editor v-else-if="field.field_type === 'Image'"
                      :key="field.id + 'ImageEditor'" :document="document"
                      :field="field" :table="table"></image-editor>

        <select-related-object v-if="field.field_type === 'Link to Object'" class="pt-1"
                               :key="field.id + 'link'" :document="document"
                               :field="field" :table="table"></select-related-object>

        <div v-if="field.field_type === 'Attachment'" class="w-100 my-1">
            <attachment-input :document="document" :field="field" :table="table"></attachment-input>
        </div>

        <div v-if="field.field_type === 'Text'" class="w-100 my-1">
<!--            <rich-text-editor :document="document" :field="field" :table="table"></rich-text-editor>-->
            <rich-text-editor-vue3 id="richTextInput" :document="document" :field="field" :table="table"></rich-text-editor-vue3>
        </div>

        <div v-if="required && !isValid" class="invalid-element">
            {{field.name}} is required
        </div>

    </div>
</template>

<script>

    import SelectControl from "../../components/SelectControl.vue";
    import TableUtil from "../../utils/TableUtil";
    import CheckboxView from "../../components/CheckboxView.vue";
    // import Datepicker from 'vuejs-datepicker'
    import Datepicker from 'vuejs3-datepicker';
    import DateUtil from "../../utils/DateUtil";
    import SelectCollaborator from "../../components/SelectCollaborator.vue";
    import AttachmentInput from "./AttachmentInput.vue";
    import DataService from "../../services/DataService";
    import SelectRelatedObject from "../../components/SelectRelatedObject.vue";
    import FieldValidator from "../../utils/FieldValidator";
    import ImageEditor from "../../components/ImageEditor.vue";
    import RichTextEditorVue3 from "../../components/RichTextEditorVue3.vue";

    export default {
        name: 'FormElement',
        components: {
            RichTextEditorVue3,
            ImageEditor,
            SelectRelatedObject,
            AttachmentInput, SelectCollaborator, CheckboxView, SelectControl, Datepicker
        },
        props: ['field', 'document', 'table', 'includeLabel', 'required', 'component'],
        computed: {
            formClasses() {
                return `${this.marginClasses} ${this.paddingClasses} ${this.widthClass}`.trim()
            },
            marginClasses() {
                if (this.component === undefined || !this.component.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(this.component.margin)
            },
            paddingClasses() {
                if (this.component === undefined || !this.component.padding) {
                    return ''
                }

                return webase.utils.ui.getPaddingClass(this.component.padding)
            },
            widthClass() {
                return this.hasMaxWidth ? '' : 'w-100'
            },
            isString() {
                return this.field.field_type === 'String' || this.field.field_type === 'URL'
            },
            isPassword() {
                return this.field.name.toLowerCase().indexOf('password') > -1
            },
            isPrimaryField() {
                let primaryField = this.tableUtil.getPrimaryField(this.table)
                return primaryField.id === this.field.id
            },
            textInputClasses() {
                let classes = ''

                if(this.required && !this.isValid) {
                    classes = 'is-invalid '
                }

                if(this.component) {
                    classes += this.sizeClasses
                }

                return classes
            },
            sizeClasses() {
                if (this.component && this.component.style && this.component.style.size) {
                    return this.component.style.size
                }

                return ''
            },
            maxWidthStyle() {
                if (!this.hasMaxWidth) {
                    return ''
                }

                return `max-width: ${this.component.style.maxWidth}px;`
            },
            hasMaxWidth() {
                return this.component && this.component.style && this.component.style.maxWidth
            },
            // isVerticalField() {
            //     return this.field.field_type === 'Text' || this.field.field_type === 'Attachment' ||
            //         this.field.field_type === 'Link to Object'
            // }
        },
        data() {
            return {
                model: this.$root.model,
                service: new DataService(this.table.id),
                tableUtil: new TableUtil(),
                isValid: true,
                autoSave: false, // added to fix duplicate saves without removing the save code... safe to delete if auto-save solved or can be ignored
            }
        },
        mounted() {
        },
        methods: {
            dateClosed() {
                let fieldValue = this.document[this.field.index]
                let dateUtil = new DateUtil()

                if (dateUtil.isValidDate(fieldValue)) {
                    // Storing the date as a string in this format breaks sorting
                    // this.document[this.field.index] = dateUtil.formatDate(fieldValue)
                    this.saveDocument()
                }
            },
            onValidateNumber() {
                this.isValid = this.validateField()

                if (!this.isValid) {
                    return
                }

                if (this.document[this.field.index]) {
                    this.document[this.field.index] = Number(this.document[this.field.index])
                    this.saveDocument()
                }

            },
            saveDocument() {

                this.isValid = this.validateField()

                if (!this.isValid) {
                    return
                }

                if (!this.model.auth_token) {
                    return
                }

                if(!this.autoSave) {
                    return
                }

                if (this.isPrimaryField && this.document[this.field.index]) {
                    this.service.save(this.document)
                    return
                }

                if (this.document['id'] && this.document[this.field.index]) {
                    this.service.save(this.document)
                }
            },
            validateField() {
                if (this.required) {
                    let validator = new FieldValidator(this.field, this.document)
                    return validator.isValid()
                }

                return true

                // let validator = new FormValidator(this.table, this.document)
                // return validator.isFieldValid(this.field)
            }
        }
    }
</script>
